export const initialState = {
  todos: []
};